import React, { useState } from "react";

export default function CommentForm({
  label,
  formSubmit,
  formCancel = null,
  initialText = "",
  loading = false,
}) {
  const [value, setValue] = useState(initialText);

  const commentChange = (newValue) => {
    setValue(newValue);
  };

  const submitComment = (e) => {
    e.preventDefault();
    formSubmit(value);
    setValue("");
  };

  return (
    <form onSubmit={submitComment}>
      <div className="flex flex-col items-end border border-dark-light rounded-lg p-4">
        <textarea
          className="w-full focus:outline-none bg-transparent"
          rows="5"
          placeholder="Wrtie a comment..."
          value={value}
          onChange={(e) => commentChange(e.target.value)}
        />
        <div className="flex flex-col-reverse gap-y-2 min-[420px]:flex-row items-center gap-x-2 pt-2">
          {formCancel && (
            <button
              onClick={formCancel}
              className="mt-2 px-6 py-2.5 rounded-lg text-red-500 font-semibold border-2  border-red-500 hover:bg-red-500 hover:border-red-500 hover:text-white transition-all duration-300"
            >
              Cancel
            </button>
          )}
          <button
            disabled={loading}
            type="submit"
            className="mt-2 px-6 py-2.5 rounded-lg text-dark-light font-semibold border-2  border-dark-light hover:bg-primary hover:border-primary hover:text-white transition-all duration-300 disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {label}
          </button>
        </div>
      </div>
    </form>
  );
}
